import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmokingRoomsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"smoking_rooms"}/>
}
